// extracted by mini-css-extract-plugin
module.exports = {"userPanel":"UserPanel_userPanel__1Sb6v","deleteButton":"UserPanel_deleteButton__2sZ_k"};